import React from "react";
import { Layout } from "antd";
import AppRoutes from "./Content";
import "../../main.scss";

import Header from "./Header/Header";
import { Footer } from "./Footer";
import { Social } from "./Social";
import LetConnect from "../LetConnect/LetConnect";
const AppLayout = (props: any) => {
  return (
    <Layout style={{ background: "#1d1a36" }}>
      <Header />
      <AppRoutes />
      <LetConnect padding={true} />
      <Footer />
      <Social />
    </Layout>
  );
};
export default AppLayout;
